import { render, staticRenderFns } from "./SurveyBuilder.vue?vue&type=template&id=7b38c15a&"
import script from "./SurveyBuilder.vue?vue&type=script&lang=js&"
export * from "./SurveyBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports